import { Badge, Button, Typography } from "@c4c-web/ui";
import { PencilLineIcon, WarningOctagonIcon } from "@c4c-web/icons";
import { EAddressStatus } from "../../../constants";
import type { TranslationFn } from "../../../types";
import type { TBadgeColor } from "./address-list.interface";

export const AddressBadge = ({
  badgeTitle,
  badgeColor,
}: {
  badgeTitle?: string;
  badgeColor: TBadgeColor;
}): JSX.Element | null => {
  return badgeTitle ? (
    <Badge
      className="absolute bottom-0 right-0 rounded-bl-none rounded-br-[10px] rounded-tl-[10px] rounded-tr-none"
      color={badgeColor}
      mode="dark"
      size="xs"
    >
      {badgeTitle}
    </Badge>
  ) : null;
};

export const UnverifiedAddressMessage = ({
  status,
  t,
}: {
  status?: EAddressStatus;
  t: TranslationFn;
}): JSX.Element | null => {
  return status && status === EAddressStatus.UNVERIFIED ? (
    <div className="flex items-center justify-between gap-xs">
      <WarningOctagonIcon
        className="size-[18px] shrink-0"
        color="red-400"
        variant="thick"
      />
      <Typography className="text-red-400">
        {t("addressJourney.unverifiedAddressMessage")}
      </Typography>
    </div>
  ) : null;
};

export const AddressLabelWithEditIcon = ({
  label,
  onUpdateUnverifiedAddress,
  status,
  value,
}: {
  label: string | JSX.Element;
  onUpdateUnverifiedAddress?: (addressId: string) => void;
  status?: string;
  value: string;
}): string | JSX.Element => {
  return status === EAddressStatus.UNVERIFIED ? (
    <div className="relative flex items-center justify-between gap-md">
      {label}
      <Button
        className="border-none"
        color="primary"
        onClick={() => {
          onUpdateUnverifiedAddress?.(value);
        }}
        shape="pill"
        size="2xs"
        variant="ghost"
      >
        <PencilLineIcon />
      </Button>
    </div>
  ) : (
    label
  );
};
